<template>
  <section class="ad-shell">
    <div v-if="!clientId || !slot" class="ad-placeholder">
      <div>
        <div class="ad-kicker">Publicidad</div>
        <strong>Espacio para Google AdSense</strong>
      </div>
      <span>Se oculta automáticamente con la suscripción anual.</span>
    </div>

    <ins
      v-else
      class="adsbygoogle ad-unit"
      style="display:block"
      :data-ad-client="clientId"
      :data-ad-slot="slot"
      data-ad-format="auto"
      data-full-width-responsive="true"
    ></ins>
  </section>
</template>

<script>
let adsScriptLoading = false;

export default {
  name: 'AdBanner',
  props: {
    enabled: { type: Boolean, default: true },
  },
  data() {
    return {
      clientId: process.env.VUE_APP_ADSENSE_CLIENT || '',
      slot: process.env.VUE_APP_ADSENSE_SLOT || '',
    };
  },
  mounted() {
    if (!this.enabled || !this.clientId) return;
    this.ensureScript();
  },
  methods: {
    ensureScript() {
      const existing = document.querySelector('script[data-notas-adsense="1"]');
      if (existing) {
        this.pushAds();
        return;
      }
      if (adsScriptLoading) return;
      adsScriptLoading = true;
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${this.clientId}`;
      script.crossOrigin = 'anonymous';
      script.dataset.notasAdsense = '1';
      script.onload = () => {
        adsScriptLoading = false;
        this.pushAds();
      };
      script.onerror = () => {
        adsScriptLoading = false;
      };
      document.head.appendChild(script);
    },
    pushAds() {
      this.$nextTick(() => {
        if (!this.clientId || !this.slot) return;
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (error) {
          // noop in local previews
        }
      });
    },
  },
};
</script>

<style scoped>
.ad-shell {
  width: 100%;
}
.ad-placeholder,
.ad-unit {
  width: 100%;
  min-height: 110px;
  border-radius: 24px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  background: rgba(255, 255, 255, 0.76);
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.06);
}
.ad-placeholder {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  color: #475569;
}
.ad-kicker {
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 6px;
}
.ad-placeholder strong {
  display: block;
  color: #0f172a;
  font-size: 18px;
}
.ad-placeholder span {
  max-width: 280px;
  text-align: right;
  font-size: 14px;
}
@media (max-width: 720px) {
  .ad-placeholder {
    flex-direction: column;
    align-items: flex-start;
  }
  .ad-placeholder span {
    text-align: left;
  }
}
</style>
